export default {
  label: "搜索输入框",
  type: "search",
  property: "",
  value: "",
  options: {
    placeholder: "请输入",
  },
};
